<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card v-if="!good" class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Cattle Drive Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div v-if="this.count < this.totalRiders" class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE APPLICATION</div>
        <div v-else class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE WAIT LIST</div>

        <div class="headline text-xs-center">
          <p>June 15 - 19, 2025</p>
        </div>

        <div class="headline text-xs-center">
          <p>Cattle Drive Registration starts Aug 6th 2024</p>
        </div>
      </v-card>
      <v-card v-else class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Cattle Drive Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div v-if="this.count < this.totalRiders" class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE APPLICATION</div>
        <div v-else class="headline text-xs-center blue--text">{{ currentYear }} RENO RODEO ASSOCIATION CATTLE DRIVE WAIT LIST</div>

        <div class="headline text-xs-center">
          <p>June 15 - 19, 2025</p>
        </div>

        <div v-if="saved">
          <div v-if="this.count < this.totalRiders" class="subheading mx-4">
            <h2>Congratulations, please check your email for confirmation and payment receipt.</h2>
          </div>
          <div v-else class="subheading mx-4">
            <h2>Thank you! You have been added to the wait list.</h2>
          </div>
        </div>
        <div v-else>
        <div class="headline text-xs-center">
          <p>Please Print Clearly and Accurately</p>
        </div>

        <div class="headline text-xs-center mt-4">
          <span class="red--text">All information is required.</span>
        </div>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
        <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Rider Name"
                    ref="focusName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md6>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md6>
                      <v-text-field
                        v-model="editedItem.state"
                        label="State/Province"
                        :rules="[v => !!v || 'State/Province is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Postal Code"
                        :rules="[v => !!v || 'Postal Code is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.country"
                        label="Country"
                        :rules="[v => !!v || 'Country is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.primaryPhone"
                    label="Primary Phone"
                    prepend-icon="stay_current_portrait"
                    mask="(###) ###-####"
                    return-masked-value
                    :rules="[v => !!v || 'Primary Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.secondaryPhone"
                    label="Secondary Phone"
                    prepend-icon="phone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="editedItem.age"
                    label="Age"
                    mask="###"
                    :rules="[v => !!v || 'Age is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="editedItem.weight"
                    label="Weight (Max 240lbs.)"
                    mask="###"
                    :rules="[v => !!v || 'Weight is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-text-field
                    v-model="editedItem.height"
                    label="Height"
                    :rules="[v => !!v || 'Height is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md3>
                  <v-select
                    v-model="editedItem.sex"
                    :items="sexs"
                    label="Sex"
                    :rules="[v => !!v || 'You must choose your sex!']"
                    required
                  ></v-select>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">EMERGENCY CONTACT</span>
                </v-flex>
                <v-flex xs12 md8>
                  <v-text-field
                    v-model="editedItem.contactName"
                    @keyup.enter="save"
                    label="Contact Name"
                    :rules="[v => !!v || 'Contact Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="editedItem.contactPhone"
                    @keyup.enter="save"
                    label="Contact Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    :rules="[v => !!v || 'Contact Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">HORSE EXPERIENCE</span>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group
                    v-model="editedItem.experience"
                    :rules="[v => !!v || 'Experience is required']"
                    required
                  >
                    <v-radio label="Eight hours in the saddle is no big deal, and I can handle and enjoy myself on any horse. I am an experienced trail rider and have ridden many times. I know how to change leads and the difference between a canter, a lope and a trot." value="Expert"></v-radio>
                    <v-radio label="I can get a horse to walk, trot and lope without any problem, but I’m not ready to enter the pro class in the West Coast Cutting Horse Finals." value="Experienced"></v-radio>
                    <v-radio label="I have ridden some, although not very often. I understand the basics mechanics of go, stop and turn and can stay in the saddle." value="Rides"></v-radio>
                    <v-radio label="I have ridden once or twice and done OK." value="Novice"></v-radio>
                    <v-radio label="I have never ridden a horse, but am looking forward to a new experience and a great vacation." value="Beginner"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">GUEST INFORMATION</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.otherRiders"
                    label="1. If you are joining us with a friend or a group and wish to be on the same team, please list the name(s)."
                    prepend-icon="mdi-account-group"
                ></v-text-field>
                </v-flex>
                <v-flex xs12>
                <v-textarea
                  v-model="editedItem.medicalConditions"
                  label="2. If you have any medical conditions or dietary restrictions (heart condition, diabetes, vegetarian etc.) that we should be aware of, please explain"
                  prepend-icon="mdi-medical-bag"
                  :rules="[v => !!v || 'Medical conditions is required']"
                  required
              ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    v-model="editedItem.whyGo"
                    label="3. We would like to know what prompted you to participate in the 2025 Reno Rodeo Cattle Drive. Are you going on the Cattle Drive for a special reason? To celebrate a birthday or anniversary? To accompany a friend or relative? Please tell us about it."
                    prepend-icon="notes"
                    :rules="[v => !!v || 'What prompted you to participate is required']"
                    required
                  ></v-textarea>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" class="title text-xs-center mt-4" xs12>
                  <span class="blue--text">CREDIT CARD INFORMATION</span>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12>
                  <v-text-field
                    v-model="editedItem.number"
                    label="Credit Card Number"
                    :rules="[v => !!v || 'Credit Card Number is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12>
                  <v-text-field
                    v-model="editedItem.cardName"
                    label="Name on Card"
                    :rules="[v => !!v || 'Name on Card is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs6 md3>
                  <v-text-field
                    v-model="editedItem.expire"
                    label="Expires"
                    mask="##/##"
                    return-masked-value
                    :rules="[v => !!v || 'Expires is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12 md3 offset-md1>
                  <v-text-field
                    v-model="editedItem.cvv"
                    label="CVV"
                    mask="####"
                    :rules="[v => !!v || 'CVV is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="this.count < this.totalRiders" xs12 md3 offset-md1>
                  <v-text-field
                    v-model="editedItem.amount"
                    label="Amount"
                    :rules="[v => !!v || 'Amount is required']"
                    mask="####.##"
                    prefix="$"
                    readonly
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

        <div class="title text-xs-center mb-4">
          <span v-if="this.count < this.totalRiders" class="blue--text">REGISTRATION INFORMATION</span>
          <span v-else class="blue--text">WAIT LIST INFORMATION</span>
        </div>

        <div class="subheading mx-4">
          <div v-if="this.count < this.totalRiders">
            <p><strong>Important Dates:</strong>
              <ul>
                <li>March 14, 2025 - Last day to cancel and request refund (less $1,000 processing fee).</li>
                <li>June 15, 2025 - <strong>The adventure begins!!!!</strong></li>
              </ul>
            </p>

            <p><strong>Fees:</strong><br />
              The cost for the 2025 Reno Rodeo Cattle Drive will be $2,800 per person. This <strong>includes</strong> your horse, all meals, ground
              transportation and <u>lot of fun</u>!!!
            </p>

            <p>Confirmed reservations will be on a first come first served basis until we are full. Simply put, we will not hold a space for you,
              unless we’ve received the $2,800.00 payment in full. Payment in full must be received in the Rodeo Office at the time of application.
              If we do not receive full payment your spot will be given someone on the waiting list.
            </p>

            <p><strong>Refund/Cancellation Policy:</strong><br />
              <span class="red--text">You have until March 14th, 2025 to request a refund. The refund request must be in writing. We will refund your
                deposit, minus a $1,000 processing fee, if we receive the written request before the deadline. A doctor’s request will not waive
                the processing fee.</span>
            </p>

            <p>We will not process refunds after March 14th, 2025, and your full payment will be forfeited if you do not attend.</p>
          </div>

          <p><strong>Rules of the Cattle Drive:</strong><br />
            <ul>
              <li>No guest will be allowed to bring his or her horse on the cattle drive. <strong>NO EXCEPTIONS.</strong></li>
              <li>All riders must be <strong>18</strong> years of age.</li>
              <li>No alcoholic beverages while riding.</li>
              <li>No firearms are allowed. Even if you have a CCW, leave it at home.</li>
              <li>Willful disregard for the rules or acts of disorderliness will not be tolerated. In the interest of the safety and to ensure the
                pleasurable experience for the other guests, the Trail Boss or the Cow Boss may remove a guest at anytime from the Drive who
                demonstrates these characteristics. Any mistreatment of animals or public drunkenness will also get you a ride back to town.</li>
            </ul>
          </p>
        </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-checkbox
            v-model="checkbox"
            label="I have read and agree to the Registration Information, and acknowledge the Fee, Refund and Cancellation policies!"
            :rules="[v => !!v || 'You must agree to continue!']"
            required
          ></v-checkbox>
          <v-btn v-if="this.count < this.totalRiders" color="primary" @click="save">Submit Application</v-btn>
          <v-btn v-else @click="save">Submit to Wait List</v-btn>
        </v-card-actions>
      </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      count: 0,
      good: false,
      saved: false,
      totalRiders: 5,
      currentYear: 0,
      checkbox: false,
      sexs: ['Male', 'Female'],
      editedItem: {},
      amount: '2800.00',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.good = true
    this.editedItem.amount = this.amount
    this.getDate()
    this.getCount()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async getCount () {
      console.log(this.currentYear)
      try {
        const response = await Api().get('get_cdcount/' + this.currentYear)
        this.count = response.data.length
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear
        this.getCount()

        console.log(this.count, this.totalRiders)
        if (this.count > this.totalRiders) {
          this.editedItem.status = 'Wait List'
        }

        console.log(this.editedItem)

        if (this.$refs.form.validate()) {
          if (this.count > this.totalRiders) {
            const response = await Api().post('extern_cattledrive', this.editedItem)
            console.log(response.data)

            this.snackbar.message = 'Congratulation, you have been added to the Wait List'
          } else {
            const response = await Api().post('extern_cd_payment', this.editedItem)
            console.log(response.data)

            this.snackbar.message = 'Congratulation, your registration has been submitted!'
          }

          this.saved = true
          window.scrollTo(0, 0)

          // this.snackbar.color = 'success'
          // this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cattleDrive/ExternalForm.vue